import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';
import OrderShipmentProduct from './shipments/OrderShipmentProduct';
import { ProductConfiguration } from '../../../products/productConfiguration';

export default class OrderLineItemsComponent extends React.PureComponent {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    loadOrder: PropTypes.func.isRequired,
  };

  render() {
    const { order, loadOrder } = this.props;
    return (
      <div className="line-items">
        {order.lineItems.map((lineItem, i) => (
          <div className="card shipment-line-item order-shipment" key={i}>
            <OrderShipmentProduct
              order={order}
              lineItem={lineItem}
              productConfiguration={this.props.productConfiguration}
              shipment={order.shipments.find(
                (x) => x.id === lineItem.shipmentId
              )}
              loadOrder={loadOrder}
              enabledAddCustomerApproval={false}
              enabledNewTask={false}
            />
          </div>
        ))}
      </div>
    );
  }
}
